import { Box, Stack } from '@mantine/core'
import React from 'react'
import { Col, Row } from 'react-bootstrap'

import Alert from '../../../../../1stlog-ui/src/components/Alert'
import Checkbox from '../../../../../1stlog-ui/src/components/Checkbox'
import Field, {
  composeValidators,
  useField,
} from '../../../../../1stlog-ui/src/components/Field'
import FilePicker, {
  minFileCount,
  validateFileCount,
} from '../../../../components/FilePicker'
import OrderEntryCard, {
  IOrderEntryCardProps,
} from '../../components/OrderEntryCard'
import { useProductSettings } from '../../Products'
import { TradeInvoiceUpload } from './TradeInvoiceUpload'
import { AdditionalCustomsDocs } from './AdditionalCustomsDocs'

interface TInvoiceUploadProps
  extends Omit<IOrderEntryCardProps, 'title' | 'children'> {
  alwaysRenderProforma?: boolean
}

const InvoiceUpload = (props: TInvoiceUploadProps): React.ReactElement => {
  const { alwaysRenderProforma } = props
  const { enableProforma, isInvoiceUploadRequired, disableDocumentUpload } =
    useProductSettings()

  const isProformaVisible = enableProforma || alwaysRenderProforma

  const proformaInvoice = useField('proformaInvoice', { ignorePrefix: true })

  const isInvoiceRequired = isProformaVisible
    ? !proformaInvoice
    : isInvoiceUploadRequired !== false

  if (disableDocumentUpload) {
    return <></>
  }

  return (
    <OrderEntryCard
      {...props}
      title={i18n.t('invoice_documents', 'Rechnung und Zolldokumente')}
    >
      {isProformaVisible && (
        <Row>
          <Col>
            <Field name="proformaInvoice">
              <Checkbox
                id="generateProformaId"
                label={i18n.t(
                  'create_proforma_label',
                  'Proformarechnung erstellen',
                )}
              />
            </Field>
          </Col>
        </Row>
      )}
      {proformaInvoice && (
        <div>
          <Alert info>
            {i18n.t(
              'info_required_customs_goods',
              'Da eine Proformarechnung erstellt werden soll, müssen Sie alle zollpflichtigen Waren unten eintragen. Eine Handelsrechnung kann hochgeladen werden, ist aber optional.',
            )}
          </Alert>
        </div>
      )}
      <Stack spacing="xl">
        <TradeInvoiceUpload isRequired={isInvoiceRequired} />
        <AdditionalCustomsDocs />
      </Stack>
    </OrderEntryCard>
  )
}

export default InvoiceUpload
